import { InjectionToken } from '@angular/core';
import { GoogleMapsConfig } from './google-maps.interface';

export const GOOGLE_MAPS_CONFIG = new InjectionToken<GoogleMapsConfig>(
  'GoogleMapsConfig',
);
